import { ReactNode } from 'react'

interface RootLayoutProps {
    children: ReactNode
}

export default function RootLayout({ children }: RootLayoutProps) {
    return <div className="flex flex-col min-h-screen bg-white">{children}</div>
}
